/**
 * WebSocket Subscription Queries
 * These queries are ONLY for WebSocket subscriptions, not for regular GraphQL API calls
 * Contains only the actual queries being used in the codebase
 */

export const WEBSOCKET_SUBSCRIPTIONS = {
  /**
   * Subscribe to transfer patient notifications with assignedCSId
   * Used in: useGlobalNotifications.ts
   */
  SUBSCRIBE_TRANSFER_PATIENT_NOTIFICATIONS: `
    subscription MyQuery($assignedCSId: Int!) {
      pep_vw_patient_user_transfer(
        where: {
          _or: [
            {assigned_to_user: {_is_null: true}},
            {assigned_to_user: {_eq: $assignedCSId}}
          ]
        }
      ) {
        transfer_id
        enrollment_patient_id
        patient_name
        clinic_id
        clinic_name
        assigned_by_user_id
        assigned_by_user_name
        assigned_to_user
        assigned_to_user_name
        assigned_dt
      }
    }
  `,

  /**
   * Subscribe to specific transfer patient updates with transferId
   * Used in: vpeService.ts, patientEnrollmentService.ts, usePatientTransfer.ts, useESPatientOperations.ts
   */
  TRANSFER_PATIENT_SUBSCRIPTION: `
    subscription MyQuery($transferId: Int!) {
      pep_vw_transfer_patient_list(where: {id: {_eq: $transferId}, assigned_cs_id: {_is_null: false}}) {
        id
        care_specialist
      }
    }
  `
};

export default WEBSOCKET_SUBSCRIPTIONS;